/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { TextField, PhoneNumberField } from 'sarsaparilla';

const propTypes = {
    validation: PropTypes.object.isRequired,
    reservation: PropTypes.object.isRequired,
    pActions: PropTypes.object.isRequired,
    displayValidationError: PropTypes.bool,
};
const EMERGENCY_CONTACT_PROP_PATH = 'emergency_contact';

export default class EmergencyContact extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onFormValidate = this.onFormValidate.bind(this);
    }

    onFormValidate(isInValid, error, path) {
        if (isInValid) {
            this.props.pActions.formValidationChange(
                `${this.props.reservation.id}_${path}`,
                error
            );
        } else {
            this.props.pActions.formValidationChange(
                `${this.props.reservation.id}_${path}`,
                null
            );
        }
    }

    handleChange(event) {
        const { reservation } = this.props;
        const contact = get(reservation, EMERGENCY_CONTACT_PROP_PATH, {});
        const contactObj = { ...contact };
        switch (event.target.id) {
            case 'emergency-contact-firstname':
                contactObj.first_name = event.target.value;
                break;
            case 'emergency-contact-lastname':
                contactObj.last_name = event.target.value;
                break;
            case 'emergency-contact-phone-num':
                contactObj.phone = event.target.value;
                break;
            default:
                return;
        }
        this.props.pActions.updatePendingReservation(
            reservation.id,
            EMERGENCY_CONTACT_PROP_PATH,
            contactObj
        );
    }

    render() {
        const { reservation, addToInputRefs, vIndex } = this.props;
        const firstName = get(
            reservation,
            `${EMERGENCY_CONTACT_PROP_PATH}.first_name`,
            ''
        );
        const lastName = get(reservation, `${EMERGENCY_CONTACT_PROP_PATH}.last_name`, '');
        const phone = get(reservation, `${EMERGENCY_CONTACT_PROP_PATH}.phone`, '');
        return (
            <div className="permit-emergency-contact-wrap">
                <h2>Emergency Contact</h2>
                <p>
                    Please provide the contact info for a person not attending your trip
                    that can be reached in the event of a facility-wide emergency.
                </p>
                <div className="rec-nested-wrap">
                    <div className="rec-grid-4-12">
                        <div className="rec-form-item-wrap">
                            <TextField
                                id="emergency-contact-firstname"
                                label="First Name"
                                ref={addToInputRefs(vIndex + 19)}
                                value={firstName}
                                isRequired
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="rec-grid-4-12">
                        <div className="rec-form-item-wrap">
                            <TextField
                                id="emergency-contact-lastname"
                                label="Last Name"
                                ref={addToInputRefs(vIndex + 20)}
                                value={lastName}
                                isRequired
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="rec-grid-4-12">
                        <div className="rec-form-item-wrap">
                            <PhoneNumberField
                                id="emergency-contact-phone-num"
                                label="Phone Number"
                                ref={addToInputRefs(vIndex + 21)}
                                value={phone}
                                isRequired
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

EmergencyContact.propTypes = propTypes;
